// Smart Sash Admin Panel - Certification Constants
// Constants and default values for certification questions

import { CertificationAnswer, QuestionType } from '@/models/certification.models';

/**
 * Valid answer IDs (a through h)
 */
export const ANSWER_IDS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'] as const;

/**
 * Type for valid answer IDs
 */
export type AnswerId = (typeof ANSWER_IDS)[number];

/**
 * Required number of answers per question
 */
export const REQUIRED_ANSWER_COUNT = 8;

/**
 * Default question field values
 */
export const DEFAULT_QUESTION_VALUES = {
  question: '',
  questionType: QuestionType.MultipleChoice,
  correctAnswer: 'a',
  points: 1,
  isActive: true,
} as const;

/**
 * Create an empty answer with the given ID
 */
export const createEmptyAnswer = (id: string): CertificationAnswer => ({
  id,
  text: '',
  isCorrect: false,
});

/**
 * Default empty answers array (a through h)
 */
export const createDefaultAnswers = (): CertificationAnswer[] =>
  ANSWER_IDS.map((id) => createEmptyAnswer(id));